module.exports = __webpack_public_path__ + "static/media/Haxorus_gaussian2.d182472a.png";